module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "modal-title": 'Edit Rule'
    },
    on: {
      "save": function($event) {
        return _vm.save()
      },
      "close": _vm.close
    }
  }, [_c('FormulateForm', [_c('FormulateInput', {
    attrs: {
      "type": "checkbox",
      "label": "Active"
    },
    model: {
      value: (_vm.model.active),
      callback: function($$v) {
        _vm.$set(_vm.model, "active", $$v)
      },
      expression: "model.active"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "select",
      "label": "Scoring Model",
      "validation": "required",
      "options": _vm.scoringModelsOptions
    },
    model: {
      value: (_vm.model.scoring_model_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "scoring_model_id", $$v)
      },
      expression: "model.scoring_model_id"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "select",
      "label": "Test Scoring Models",
      "multiple": "true",
      "options": _vm.testScoringModelsOptions
    },
    model: {
      value: (_vm.model.test_scoring_models_ids),
      callback: function($$v) {
        _vm.$set(_vm.model, "test_scoring_models_ids", $$v)
      },
      expression: "model.test_scoring_models_ids"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "range",
      "label": "Rate",
      "min": "0",
      "max": "100",
      "validation": "required|min:0|max:100",
      "show-value": "true"
    },
    model: {
      value: (_vm.model.rate),
      callback: function($$v) {
        _vm.$set(_vm.model, "rate", $$v)
      },
      expression: "model.rate"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c6fa35c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/ScoringModelRuleModal.vue
// module id = 639
// module chunks = 0